import React from 'react';
import { IMatrixMessage } from '../../../client/message/types';

interface RoomCreateMessageProps {
  message: IMatrixMessage;
  className?: string;
}

export const RoomCreateMessage = ({ message, className = '' }: RoomCreateMessageProps) => {
  const sender = message.content.creator;
  const version = message.content.room_version;
  return (
    <div
      className={`room-create-message ${className}`}
      style={{
        color: '#fff',
        background: '#1976d2',
        borderRadius: 6,
        padding: '8px 12px',
        fontWeight: 500,
        display: 'inline-block',
        maxWidth: '100%',
      }}
    >
      {sender ? `${sender} 创建了房间（版本 ${version}）` : `房间已创建（版本 ${version}）`}
    </div>
  );
}; 